import React from 'react';
import { styled } from '@compiled/react';
import Heading from '@atlaskit/heading';
import { token } from '@atlaskit/tokens';
import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { FireScreenAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { useProjectSimplified } from '@atlassian/jira-software-report-charting-common/src/services/get-project/index.tsx';
import lockImageUrl from './assets/lock-closed.svg';
import messages from './messages.tsx';

const useHelpLink = (): string | undefined => {
	const isSimplified = useProjectSimplified();
	if (isSimplified === null) {
		return undefined;
	}
	return isSimplified
		? 'https://support.atlassian.com/jira-software-cloud/docs/next-gen-permissions/#Overviewofpermissionsinnextgenprojects-Projectpermissions'
		: 'https://support.atlassian.com/jira-cloud-administration/docs/permissions-for-company-managed-projects';
};

const NoPermissionForAnyIssues = () => {
	const { formatMessage } = useIntl();
	const helpLink = useHelpLink();

	return (
		<Container data-test-id="software-deployment-frequency-report-deployment-details-dialog.ui.body.no-permission.container">
			<FireScreenAnalytics attributes={{ noPermissionForAnyIssues: true }} />
			<img src={lockImageUrl} alt="" width={14 * gridSize} />
			<Explanation>
				<Heading size="large">{formatMessage(messages.title)}</Heading>
				<p>
					{formatMessage(messages.description)}{' '}
					<a href={helpLink} target="_blank">
						{formatMessage(messages.learnMore)}
					</a>
				</p>
			</Explanation>
		</Container>
	);
};

export default NoPermissionForAnyIssues;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Container = styled.div({
	height: '380px',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Explanation = styled.div({
	width: '420px',
	marginLeft: token('space.800', '64px'),
});
